import { useEffect, useState } from 'react';
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import layoutConf from "../../config/layoutConf";
import ProcessCategoryMaster from "./ProcessCategoryMaster";
import ProcessCategoryDetail from "./ProcessCategoryDetail";

function ProcessCategory ( props ) {
    const [height, setHeight] = useState(0);
    const [selectMstGrid, setSelectMstGrid] = useState();

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const masterGridSetting = (data) => {
        setSelectMstGrid(data)
    } 

    return (
        <div style={{height: height}}>
            <ReflexContainer orientation="horizontal">
                <ReflexElement flex={0.5} data-cy="ProcessCategoryMaster">
                    <ProcessCategoryMaster 
                        id="ProcessCategoryMaster" 
                        masterGridSetting={masterGridSetting}
                    />
                </ReflexElement>

                <ReflexSplitter style={{height: layoutConf.reflex.splitterHeight}} />

                <ReflexElement data-cy="ProcessCategoryDetail">
                    {
                        (selectMstGrid)
                        ?
                        <ProcessCategoryDetail 
                            id="ProcessCategoryDetail" 
                            selectMstGrid={selectMstGrid}
                        />
                        :
                        <></>
                    }
                </ReflexElement>
            </ReflexContainer>
        </div>
    );
}

export default ProcessCategory;
